/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import PreSurgerySurveyFilledJournalEvent from "parog-web/models/pre-surgery-survey-filled-journal-event";

export default class extends CrudJournalEventBaseComponent<PreSurgerySurveyFilledJournalEvent> {
  static forcDisplayName = "Questionnaire pré-opératoire";
  static fullComponentId = "pre-surgery/consult-form";

  static journalEventClass = PreSurgerySurveyFilledJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get sections(): Array<string> {
    return PreSurgerySurveyFilledJournalEvent.sections;
  }
}
